import 'regenerator-runtime/runtime';
import { call, select, takeEvery } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  WrappedSavedStates,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import { App, StandaloneProdukt, Vorvertrag } from '@ps20-frontend/frontend-models';
import { BasicVertragsdaten, Feature } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../localStore';

export function* watchLoadVorvertraegeSaga() {
  yield takeEvery(
    GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL,
    safeSaga(checkLoadVorvertraege, App.SHOP),
  );
  yield takeEvery(GlobalActions.SAVED_STATES_LOADED, safeSaga(checkLoadVorvertraege, App.SHOP));
  yield takeEvery(GlobalActions.CHECK_VORVERTRAEGE, safeSaga(checkLoadVorvertraege, App.SHOP));
}

export function* checkLoadVorvertraege(action: AnyAction) {
  const state: IAppState = yield select();
  let kundennummer = state.transientState.loadVorvertraege.kundennummer;
  if (
    state.transientState.featureToggles &&
    state.transientState.featureToggles[Feature.TEST_DATA] &&
    state.transientState.testDaten
  ) {
    kundennummer = JSON.parse(state.transientState.testDaten).kundennummer || kundennummer;
  }

  const vermittlernummer = state.transientState.loadVorvertraege.vermittlernummer;
  const perId = state.transientState.datenhaltung.kdv.perId;
  const isNewVorgang =
    action.type === GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL &&
    state.transientState.datenhaltung.av.cryptId == null;
  if (kundennummer != null || action.type === GlobalActions.CHECK_VORVERTRAEGE) {
    const globalPut = GlobalPut.getInstance();
    if (shouldUpdateVorvertraege(action.type, state, isNewVorgang)) {
      let fremdStandard: Array<BasicVertragsdaten> = [];
      let fremdStandalone: Array<BasicVertragsdaten> = [];
      if (action.type === GlobalActions.SAVED_STATES_LOADED) {
        const actionPayload: WrappedSavedStates = (action as GlobalAction<WrappedSavedStatesLoaded>)
          .payload.savedStatesLoaded;
        const fremdvertraege = getFremdvertraege(actionPayload);
        fremdStandard = fremdvertraege.fremdStandard;
        fremdStandalone = fremdvertraege.fremdStandalone;
        yield call(
          globalPut.put,
          new GlobalActions().loadVorvertraege(
            kundennummer,
            vermittlernummer,
            perId,
            isNewVorgang,
            fremdStandard,
            fremdStandalone,
          ),
        );
      } else {
        yield call(
          globalPut.put,
          new GlobalActions().loadVorvertraege(kundennummer, vermittlernummer, perId, isNewVorgang),
        );
      }
    }
  }
}

function getFremdvertraege(actionPayload: WrappedSavedStates): {
  fremdStandard: Array<BasicVertragsdaten>;
  fremdStandalone: Array<BasicVertragsdaten>;
} {
  const fremdStandard: Array<BasicVertragsdaten> = [];
  const fremdStandalone: Array<BasicVertragsdaten> = [];
  const loadedAppState = actionPayload.find(
    loadedState => loadedState.appId === App.SHOP_DASHBOARD,
  );
  if (loadedAppState?.state.fremdVertraege) {
    const fremdVertraege = loadedAppState.state.fremdVertraege as Array<
      StandaloneProdukt | Vorvertrag
    >;
    fremdVertraege.forEach(vorvertrag => {
      const operatingVertrag: BasicVertragsdaten = {
        vertragsnummer: vorvertrag.vertragsnummer,
        spLaufnummer: vorvertrag.spLaufnummer,
        storniert: vorvertrag.isStorniert,
        stornoDetail: vorvertrag.stornoDetail,
        verkaufsangebotKurznamen: vorvertrag.verkaufsangebotKurznamen,
      };
      if ((vorvertrag as StandaloneProdukt).einschliessenDetails != null) {
        fremdStandalone.push(operatingVertrag);
      } else {
        fremdStandard.push(operatingVertrag);
      }
    });
  }
  return { fremdStandard, fremdStandalone };
}

function shouldUpdateVorvertraege(actionType: string, _state: IAppState, isNewVorgang: boolean): boolean {
  const loadSavedVorgang = actionType === GlobalActions.SAVED_STATES_LOADED;
  const simpleCheckVorvertraege = actionType === GlobalActions.CHECK_VORVERTRAEGE;
  return isNewVorgang || loadSavedVorgang || simpleCheckVorvertraege;
}
